module.exports = __webpack_public_path__ + "img/aiMessage.c0d7a16a.png";